import { render, staticRenderFns } from "./PencilIcon.vue?vue&type=template&id=748cbaff&scoped=true&"
import script from "./PencilIcon.vue?vue&type=script&lang=js&"
export * from "./PencilIcon.vue?vue&type=script&lang=js&"
import style0 from "./PencilIcon.vue?vue&type=style&index=0&id=748cbaff&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "748cbaff",
  null
  
)

export default component.exports